import MapNotesClient from '@locuslabs/map-note-client';
import * as Request from '../request';
import * as Config from '../config';

const mapNotesClient = async (stage = Config.getStage()) => {
    const accessToken = await Config.getAccessToken();
    return MapNotesClient(accessToken, stage);
};

const getMapNoteletsRequest = Request.makeRequest(mapNotesClient, 'getMapNotelets');
const getMapNoteTotalsRequest = Request.makeRequest(mapNotesClient, 'getMapNoteTally');
const getSelectedMapNoteRequest = Request.makeRequest(mapNotesClient, 'getFullMapNote');
const deleteMapNoteRequest = Request.makeRequest(mapNotesClient, 'deleteMapNote');
const updateMapNoteRequest = Request.makeRequest(mapNotesClient, 'updateMapNote');
const addCommentRequest = Request.makeRequest(mapNotesClient, 'addMapNoteComment');
const createMapNoteRequest = Request.makeRequest(mapNotesClient, 'createMapNote');
const deleteCommentRequest = Request.makeRequest(mapNotesClient, 'deleteMapNoteComment');

const MapNotes = {
    getMapNotelets: venueId => getMapNoteletsRequest(Config.getAccountId(), venueId),
    getMapNoteTotals: venueId => getMapNoteTotalsRequest(Config.getAccountId(), { venueId }),
    getSelectedMapNote: (venueId, noteId) => getSelectedMapNoteRequest(Config.getAccountId(), venueId, noteId),
    deleteMapNote: (venueId, noteId, email) => deleteMapNoteRequest(Config.getAccountId(), venueId, noteId, email),
    updateMapNote: (venueId, noteId, changes) => updateMapNoteRequest(Config.getAccountId(), venueId, noteId, changes),
    addMapNoteComment: (venueId, email, noteId, comment) => addCommentRequest(Config.getAccountId(), venueId, email, noteId, comment),
    createMapNote: (venueId, email, newNote) => createMapNoteRequest(Config.getAccountId(), venueId, newNote, email),
    deleteMapNoteComment: (venueId, email, noteId, commentId) => deleteCommentRequest(Config.getAccountId(), venueId, noteId, email, commentId),
};

export { MapNotes };
